<app-page [title]="getAccessibleDashboard() | translate">
  @if (showErrorMessage()) {
    <div class="dashboard-placeholder">
      <div class="dashboard-placeholder__content">
        <h2>{{ 'dashboard.errorMessage.title' | translate }}</h2>
        <div>
          <p [innerHTML]="sanitizedMessage()"></p>
        </div>
      </div>
    </div>
  } @else {
    @defer {
      @if (powerBIEmbeddedTokenDto()) {
        <div class="report-wrapper">
          <powerbi-report
            class="report-class"
            [hidden]="hide"
            [embedConfig]="embedConfig()"
            [eventHandlers]="eventHandlersMap"></powerbi-report>
          <div class="overlay-button">
            <button motifIconButton (click)="toggleFullScreen()" [size]="BUTTON_SIZE" aria-label="Show Full Screen">
              <motif-icon [iconFunction]="IconoirExpand" size="24" title="Show Full Screen" />
            </button>
          </div>
        </div>
      } @else if (showDashboardNotConfigured()) {
        <div class="dashboard-placeholder">
          <div class="dashboard-placeholder__content">
            <h2>{{ 'dashboard.not-configured.title' | translate }}</h2>
            <p>{{ 'dashboard.not-configured.description' | translate }}</p>
          </div>
        </div>
      }
    } @placeholder {
      <div class="report-box">
        <div class="dashboard-placeholder__content">
          <h2>{{ 'dashboard.placeholder' | translate }}</h2>
        </div>
      </div>
    }
  }
</app-page>
